import { Option, none, isNone, some } from 'fp-ts/lib/Option';
import { UpdateDashboardCriteria } from 'use-case/dashboard/update/updateDashboardCriteria';

export interface UpdateDashboardPinCriteria extends UpdateDashboardCriteria {
    pinned: boolean;
}

class UpdateDashboardPinCriteriaImpl implements UpdateDashboardPinCriteria {
    constructor(readonly id: string, readonly pinned: boolean) {}
}

export class UpdateDashboardPinCriteriaBuilder {
    private id: Option<string> = none;

    private pin: Option<boolean> = none;

    static create = (): UpdateDashboardPinCriteriaBuilder => new UpdateDashboardPinCriteriaBuilder();

    withId = (id: string): UpdateDashboardPinCriteriaBuilder => {
        this.id = some(id);
        return this;
    };

    withPin = (pin: boolean): UpdateDashboardPinCriteriaBuilder => {
        this.pin = some(pin);
        return this;
    };

    build = (): UpdateDashboardPinCriteria => {
        if (isNone(this.id) || isNone(this.pin)) {
            throw new ReferenceError('Undefined prop');
        }

        return new UpdateDashboardPinCriteriaImpl(this.id.value, this.pin.value);
    };
}
